import { combineReducers, Action } from "redux";
import otpVerificationReducer from "./otpVerificationsReducer";
import companyReducer from "./companyReducer";
import jobReducer from "./jobReducer";
import dashboardCountReducer from "./dashboardCountReducer";
import authReducer from "./authReducer";
import locationReducer from "./locationReducer";
import { RESET_APP } from "../actions/resetActions";
import subscriptionReducer from "./subscriptionReducer";
import paymentsReducer from "./paymentsReducer";
import creditsReducer from "./creditsReducer";
import quizSlice from "./practiceAssignmentReducer";
import billingReducer from "./billingReducer";
// @ts-ignore
import notesReducer from "./notesReducers.js";
import piopiyReducer from "../slices/piopiySlice";
import leadReducer from "./leadReducer";
import clientSharingReducer from "./clientSharingReducer";
import clientFeedbackReducer from "./clientFeedbackReducer";
import requirementsReducer from "./requirementsReducer";
import requirementNotesReducer from "./requirementNotesReducer";
import membersReducer from "./membersReducer";
import clientsReducer from "./clientsReducer";
import activityLogReducer from "./activityLogReducer";
import aiJobPostingReducer from "./aiJobPostingReducer";
import notificationsReducer from "./notificationsReducer";
import memberStatsReducer from "./memberStatsReducer";
import sharedJobsReducer from "./sharedJobsReducer";

const appReducer = combineReducers({
  auth: authReducer,
  aiJobPosting: aiJobPostingReducer,
  otpVerification: otpVerificationReducer,
  company: companyReducer,
  job: jobReducer,
  count: dashboardCountReducer,
  location: locationReducer,
  subscriptions: subscriptionReducer,
  payments: paymentsReducer,
  credits: creditsReducer,
  quizess: quizSlice,
  billingInfo: billingReducer,
  notes: notesReducer,
  piopiy: piopiyReducer,
  lead: leadReducer,
  clientSharing: clientSharingReducer,
  clientFeedback: clientFeedbackReducer,
  requirements: requirementsReducer,
  requirementNotes: requirementNotesReducer,
  members: membersReducer,
  clients: clientsReducer,
  activityLog: activityLogReducer,
  notifications: notificationsReducer,
  memberStats: memberStatsReducer,
  sharedJobs: sharedJobsReducer,
});

// RootState type can be used to type the state parameter
export type RootState = ReturnType<typeof appReducer>;

// Type the action parameter using Redux's Action type, optionally extending it with any custom action types you have
const rootReducer = (state: RootState | undefined, action: Action<string>) => {
  if (action.type === RESET_APP) {
    state = undefined; // Reset the state to undefined, forcing reducers to return their initial state
  }

  return appReducer(state, action);
};
export default rootReducer;
